import type { JSX } from 'react';

import { Link, Route, Routes } from 'react-router-dom';

import classNames from 'classnames';
import styles from './Breadcrumbs.module.css';

const ROUTES = [
  {
    path: '/account',
    breadcrumbs: [
      {
        key: 'account',
        title: 'Account',
      },
    ],
  },
  {
    path: '/users',
    breadcrumbs: [
      {
        key: 'users',
        title: 'Users',
      },
    ],
  },
  {
    path: '/users/export',
    breadcrumbs: [
      {
        key: 'users',
        title: 'Users',
        path: '/users',
      },
      {
        key: 'export',
        title: 'Export',
      },
    ],
  },
  {
    path: '/incubators',
    breadcrumbs: [
      {
        key: 'incubators',
        title: 'Incubators',
      },
    ],
  },
  {
    path: '/incubator/create',
    breadcrumbs: [
      {
        key: 'general',
        title: 'General',
      },
      {
        key: 'incubators',
        title: 'Incubators',
      },
      {
        key: 'create',
        title: 'Create',
      },
    ],
  },
  {
    path: '/incubator/:id/*',
    breadcrumbs: [
      {
        key: 'general',
        title: 'General',
      },
      {
        key: 'incubators',
        title: 'Incubators',
      },
      {
        key: 'incubator',
        title: 'Incubator',
      },
    ],
  },
  {
    path: '/subscriptions/clients',
    breadcrumbs: [
      {
        key: 'subscriptions',
        title: 'Subscription Management',
      },
      {
        key: 'clients',
        title: 'Clients',
      },
    ],
  },
  {
    path: '/subscriptions/clients/:id',
    breadcrumbs: [
      {
        key: 'subscriptions',
        title: 'Subscription Management',
      },
      {
        key: 'clients',
        title: 'Clients',
      },
      {
        key: 'organization',
        title: 'Client Details',
      },
    ],
  },
  {
    path: '/clients',
    breadcrumbs: [
      {
        key: 'clients',
        title: 'Clients',
      },
    ],
  },
  {
    path: '/subscriptions',
    breadcrumbs: [
      {
        key: 'subscriptions',
        title: 'Subscriptions',
      },
    ],
  },
  {
    path: '/finance',
    breadcrumbs: [
      {
        key: 'finance',
        title: 'Finance',
      },
    ],
  },
  {
    path: '/invoices/new',
    breadcrumbs: [
      {
        key: 'finance',
        title: 'Finance',
        path: '/finance',
      },
      {
        key: 'new-invoice',
        title: 'New Invoice',
      },
    ],
  },
  {
    path: '/invoices/:id',
    breadcrumbs: [
      {
        key: 'finance',
        title: 'Finance',
        path: '/finance',
      },
      {
        key: 'invoice',
        title: 'Invoice',
      },
    ],
  },
  {
    path: '/catalog',
    breadcrumbs: [
      {
        key: 'catalog',
        title: 'Catalog',
        path: '/catalog',
      },
      {
        key: 'products',
        title: 'Products',
      },
    ],
  },
  {
    path: '/discounts',
    breadcrumbs: [
      {
        key: 'catalog',
        title: 'Catalog',
        path: '/catalog',
      },
      {
        key: 'discounts',
        title: 'Discounts',
      },
    ],
  },
  {
    path: '/market-config',
    breadcrumbs: [
      {
        key: 'catalog',
        title: 'Catalog',
        path: '/catalog',
      },
      {
        key: 'markets',
        title: 'Markets',
      },
    ],
  },
  {
    path: '/pricing/*',
    breadcrumbs: [
      {
        key: 'catalog',
        title: 'Catalog',
        path: '/catalog',
      },
      {
        key: 'pricing',
        title: 'Pricing',
      },
    ],
  },
  {
    path: '/product-config/*',
    breadcrumbs: [
      {
        key: 'catalog',
        title: 'Catalog',
        path: '/catalog',
      },
      {
        key: 'feature-flags',
        title: 'Feature Flags',
      },
    ],
  },
];

export default function Breadcrumbs(): JSX.Element {
  return (
    <div className={styles.BreadcrumbsContainer}>
      <Routes>
        {ROUTES.map(({ path, breadcrumbs }) => (
          <Route
            key={path}
            path={path}
            element={
              <ul className={styles.Breadcrumbs}>
                {breadcrumbs.map((item) => {
                  if ('path' in item && item.path)
                    return (
                      <Link
                        className={classNames(styles.Item, styles.Link)}
                        to={item.path}
                        key={item.key}
                      >
                        {item.title}
                      </Link>
                    );

                  return (
                    <li key={item.key} className={styles.Item}>
                      {item.title}
                    </li>
                  );
                })}
              </ul>
            }
          />
        ))}

        <Route path="*" element={<ul className={styles.Breadcrumbs} />} />
      </Routes>
    </div>
  );
}
